import { Button, Card, Col, message, Row } from "antd";
import ReactJson from "react-json-view";
import { CopyOutlined } from "@ant-design/icons";



const Component = (props: any) => {
  const { input, results } = props;
  // 复制结果
  const copyResults = () => {
    const jsonStr = JSON.stringify(results, null, 2);
    navigator.clipboard.writeText(jsonStr).then(() => {
      message.success("结果复制成功！");
    });
  };
  const copyInput = () => {
    const jsonStr = JSON.stringify(input, null, 2);
    navigator.clipboard.writeText(jsonStr).then(() => {
      message.success("输入数据复制成功！");
    });
  };
  return (
    <div style={{ padding: "16px" }}>
      <Row gutter={16}>
        <Col span={12}>
          <Card
          title={<h3>输入数据</h3>}
          extra={<Button type="primary" icon={<CopyOutlined />} onClick={copyInput}>复制输入</Button>}
          type="inner"
          >
          
          <div className="json-container">
            <ReactJson
              src={input}
              collapsed={false}
              // enableClipboard={true} // 显示复制按钮
              displayDataTypes={false} // 隐藏数据类型标签
              enableClipboard={false} // 关闭复制按钮
              displayObjectSize={false} // 不显示 12 items
              {...({ displayArrayKey: false } as any)}
              // showArrayIndexes={false}
              indentWidth={2} // 缩进宽度
              name={null} // 隐藏根节点名称
              style={{ fontSize: "14px",fontFamily:"sans-serif, Arial,monospace" }}
            />
          </div>
          </Card>
        </Col>
        <Col span={12}>
          <Card
          title={<h3>输出结果</h3>}
          extra={<Button type="primary" icon={<CopyOutlined />} onClick={copyResults}>复制输出</Button>}
          type="inner"
          >
          
          <div className="json-container">
            <ReactJson
              src={results}
              collapsed={false}
              // enableClipboard={true} // 显示复制按钮
              displayDataTypes={false} // 隐藏数据类型标签
              enableClipboard={false} // 关闭复制按钮
              displayObjectSize={false} // 不显示 12 items
              {...({ displayArrayKey: false } as any)}
              // showArrayIndexes={false}
              indentWidth={2} // 缩进宽度
              name={null} // 隐藏根节点名称
              style={{ fontSize: "14px",fontFamily:"sans-serif, Arial,monospace" }}
            />
          </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Component;
